<template>
  <b-modal
    ref="bulk-edit-bid-modal"
    id="bulk-edit-bid-modal"
    class="bulk-edit-bid-modal"
    hide-header
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div
      class="d-flex justify-content-between top-modal"
      style="margin-top: 10px;"
    >
      <div>
        <h4 class="font-medium text-primary text-capitalize">
          Bulk Edit Ad Group {{ typeEdit }}
        </h4>
        <p class="mb-0 text-placeholder">
          Set a new {{ typeEdit }} for selected ad groups in selected campaigns.
        </p>
      </div>
      <div>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideModal"
        />
      </div>
    </div>
    <div class="bulk-edit-content my-2">
      <validation-observer
        ref="formValidation"
      >
        <b-form>
          <b-form-group
            class="group-input"
            label-cols-md="3"
            content-cols-md="9"
            label="Campaign"
          >
            <b-input-group
              class="input-group-merge"
            >
              <v-select
                v-model="campaignSelected"
                style="width: 100%"
                class="input-height bulk-edit-input"
                label="name"
                :clearable="false"
                :options="campaignOptions"
              >
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <feather-icon
                      icon="ChevronDownIcon"
                      size="20"
                    />
                  </span>
                </template>
                <template #selected-option="{ name }">
                  <div
                    v-b-tooltip.hover.top.v-light.html
                    class="d-flex flex-column content-ad-account w-100"
                    :title="name ? name : '--'"
                  >
                    <span
                      class="wrap-content"
                      style="margin-right: 4px"
                    >{{ name }}</span>
                  </div>
                </template>
                <template #option="{ name }">
                  <div class="d-flex justify-content-between">
                    <span>{{ name }}</span>
                  </div>
                </template>
              </v-select>
            </b-input-group>
          </b-form-group>

          <b-form-group
            class="group-input"
            label-cols-md="3"
            content-cols-md="9"
            label="Ad Group"
          >
            <b-input-group
              class="input-group-merge"
            >
              <v-select
                v-model="adGroupSelected"
                style="width: 100%"
                class="input-height bulk-edit-input"
                :clearable="false"
                :disabled="campaignSelected.value === 'all' || isCbo"
                :options="adGroupOptions"
              >
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <feather-icon
                      icon="ChevronDownIcon"
                      size="20"
                    />
                  </span>
                </template>
                <template #selected-option="{ name }">
                  <div
                    v-b-tooltip.hover.top.v-light.html
                    class="d-flex flex-column content-ad-account w-100"
                    :title="name ? name : '--'"
                  >
                    <span
                      class="wrap-content"
                      style="margin-right: 4px"
                    >{{ name }}</span>
                  </div>
                </template>
                <template #option="{ name }">
                  <div class="d-flex justify-content-between">
                    <span>{{ name }}</span>
                  </div>
                </template>
              </v-select>
            </b-input-group>
          </b-form-group>

          <b-form-group
            class="group-input"
            label-cols-md="3"
            content-cols-md="9"
            :label="typeEdit"
          >
            <validation-provider
              v-slot="{ errors }"
              :name="typeEdit"
              :rules="targetRules()"
            >
              <b-input-group>
                <b-form-input
                  v-model="roasBid"
                  name="roasBid"
                  :placeholder="`Enter ${typeEdit} value`"
                  :state="errors.length ? false : null"
                  style="height: 42px"
                  @change="handelChangeBid($event)"
                />
              </b-input-group>
              <small
                v-if="errorBid"
                class="text-danger d-block mt-25"
              >{{ errorBid }}</small>
              <small
                v-else-if="errors[0]"
                class="text-danger d-block mt-25"
              >{{ errors[0] }}</small>
            </validation-provider>

            <p
              v-if="firstAdGroup"
              class="mb-0 mt-50 font-14 text-placeholder"
            >
              {{ convertTextBid(firstAdGroup).textDescription }}
            </p>
          </b-form-group>
        </b-form>
      </validation-observer>
    </div>

    <!-- Action Buttons -->
    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <btn-loading
          class="mr-1 border-0"
          variant-convert="btn-back"
          pill
          @click="hideModal"
        >
          Cancel
        </btn-loading>
        <btn-loading
          class="ml-1"
          variant-convert="btn-submit"
          type="submit"
          pill
          @click="confirmEdit"
        >
          Apply
        </btn-loading>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import {
  BModal,
  BInputGroup,
  BFormGroup,
  BForm, VBTooltip,
  BFormInput,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import campaignMixin from '@/mixins/campaignMixin'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import get from 'lodash/get'

const { mapGetters } = createNamespacedHelpers('campaign')

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BModal,
    BtnLoading,
    vSelect,
    BForm,
  },
  mixins: [campaignMixin],
  props: {
    campaigns: {
      type: Array,
      default: () => [],
      required: true,
    },

    adAccountSelected: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  data() {
    return {
      scheduleType: 'SCHEDULE_FROM_NOW', // or 'SCHEDULE_START_END'

      startDate: null,
      rangeDate: null,
      now: new Date(),

      messageErrorDate: '',
      messageErrorRangeDate: '',

      roasBid: '',

      typeEdit: '',

      campaignSelected: '',
      campaignOptions: [],
      adGroupSelected: '',
      adGroupOptions: [],

      updatedCampaigns: [],

      errorBid: '',
    }
  },

  computed: {
    ...mapGetters(['campaignDetail', 'status', 'message', 'loading']),
    campaign() {
      return get(this.campaignDetail, ['content'], [])[0]
    },

    isCbo() {
      return this.campaign?.budget_optimize_on && this.campaign?.budget_optimize_on === true
    },
    firstAdGroup() {
      return this.campaigns?.[0]?.adgroupList?.[0]
    },
  },

  watch: {
    campaignSelected: {
      handler(campaign) {
        const allOption = { name: 'All Ad group', value: 'all' }
        if (this.campaigns[campaign.value]) {
          this.adGroupOptions = [allOption, ...this.campaigns[campaign.value].adgroupList.map((adgroup, index) => ({
            name: adgroup.adgroupName,
            value: index,
            budget: adgroup.budget,
          }))]
        } else {
          this.adGroupOptions = [allOption]
        }
        this.adGroupSelected = allOption
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    initData() {
      this.updatedCampaigns = JSON.parse(JSON.stringify(this.campaigns))

      const allOption = { name: 'All Campaign', value: 'all' }
      this.campaignOptions = [allOption, ...this.campaigns.map((campaign, index) => ({
        name: campaign.campaignName,
        value: index,
        budget: campaign.budget,
      }))]

      this.campaignSelected = allOption
    },

    handelChangeBid(value) {
      if (this.firstAdGroup?.optimizationEvent === 'AD_REVENUE_VALUE' || (this.firstAdGroup?.optimizationEvent === 'ACTIVE_PAY' && this.firstAdGroup?.vboWindow === 'ZERO_DAY')) {
        this.roasBid = (Math.round(value * 1000) / 1000).toFixed(3)
      } else {
        this.roasBid = (Math.round(value * 100) / 100).toFixed(2)
      }
    },

    targetRules() {
      const isRoasBid = ['VALUE', 'TRAFFIC_LANDING_PAGE_VIEW'].includes(this.firstAdGroup?.optimizationGoal)
      const isConversionBidPrice = ['IN_APP_EVENT', 'INSTALL', 'CONVERT', 'LEAD_GENERATION'].includes(this.firstAdGroup?.optimizationGoal)
      const isBidPrice = ['CLICK'].includes(this.firstAdGroup?.optimizationGoal)
      if (isRoasBid) {
        const isVoMinRoas = this.firstAdGroup?.deepBidType === 'VO_MIN_ROAS'
        if (!isVoMinRoas) return ''
        if (this.firstAdGroup?.optimizationEvent === 'AD_REVENUE_VALUE') {
          return 'required|between:0.001,10'
        }
        if (this.firstAdGroup?.optimizationEvent === 'ACTIVE_PAY') {
          if (this.firstAdGroup?.vboWindow === 'ZERO_DAY') {
            return 'required|between:0.001,1000'
          } if (this.firstAdGroup?.vboWindow === 'SEVEN_DAYS') {
            return 'required|between:0.01,1000'
          }
        }
      }

      let minBudget = 0
      if (this.isCbo) {
        if (this.campaignSelected.value !== 'all') {
          minBudget = this.campaignSelected.budget
        } else {
          // Return minimum budget among all campaigns
          minBudget = this.campaigns?.reduce((min, campaign) => {
            const budget = Number(campaign.budget)
            // eslint-disable-next-line no-restricted-globals
            return !isNaN(budget) && budget < min ? budget : min
          }, Infinity) || 0
        }
      } else if (this.campaignSelected.value !== 'all') {
        if (this.adGroupSelected.value !== 'all') {
          minBudget = this.adGroupSelected.budget
        } else {
          const campaign = this.updatedCampaigns[this.campaignSelected.value]
          minBudget = campaign?.adgroupList?.reduce((min, adgroup) => {
            const budget = Number(adgroup.budget)
            // eslint-disable-next-line no-restricted-globals
            return !isNaN(budget) && budget < min ? budget : min
          }, Infinity) || 0
        }
      } else {
        // Return minimum budget among all adgroups in all campaigns
        minBudget = this.campaigns?.reduce((min, campaign) => {
          if (!campaign?.adgroupList) return min
          const campaignMin = campaign.adgroupList.reduce((adgroupMin, adgroup) => {
            const budget = Number(adgroup.budget)
            // eslint-disable-next-line no-restricted-globals
            return !isNaN(budget) && budget < adgroupMin ? budget : adgroupMin
          }, min)
          return campaignMin
        }, Infinity) || 0
      }

      if (isConversionBidPrice) {
        const max = minBudget
        if (!minBudget) {
          this.errorBid = 'The budget is required'
        } else {
          this.errorBid = ''
        }
        return `required|between:0.01,${Number(max) - 0.01}`
      }

      if (isBidPrice) {
        const budget = minBudget
        const max = Number(budget) - 0.01 > 29.99 ? 29.99 : Number(budget) - 0.01
        if (!minBudget) {
          this.errorBid = 'The budget is required'
        } else {
          this.errorBid = ''
        }
        return `required|between:0.01,${max}`
      }
      return 'required'
    },

    hideModal() {
      this.roasBid = null
      this.$refs['bulk-edit-bid-modal'].hide()
    },

    async showModal(type) {
      this.typeEdit = type

      this.initData()
      this.$refs['bulk-edit-bid-modal'].show()
    },

    getBidFieldName(optimizationGoal) {
      if (optimizationGoal === 'VALUE') return 'roasBid'
      if (['IN_APP_EVENT', 'INSTALL', 'CONVERT', 'LEAD_GENERATION'].includes(optimizationGoal)) return 'conversionBidPrice'
      if (optimizationGoal === 'CLICK') return 'bidPrice'
      return null
    },

    async confirmEdit() {
      if (this.errorBid) return
      if (await this.$refs.formValidation.validate()) {
        if (this.campaignSelected.value !== 'all') { // specific campaign
          const campaign = this.updatedCampaigns[this.campaignSelected.value]
          if (!campaign || !campaign.adgroupList) return

          if (this.adGroupSelected.value !== 'all') { // specific adgroup
            const adgroup = campaign.adgroupList[this.adGroupSelected.value]
            if (!adgroup) return

            const bidField = this.getBidFieldName(adgroup.optimizationGoal)
            if (bidField) {
              adgroup[bidField] = this.roasBid
            }
          } else {
            // all adgroups in specific campaign
            campaign.adgroupList = campaign.adgroupList.map(adgroup => {
              const bidField = this.getBidFieldName(adgroup.optimizationGoal)
              return {
                ...adgroup,
                ...(bidField && { [bidField]: this.roasBid }),
              }
            })
          }
        } else {
          // all campaigns and adgroups
          this.updatedCampaigns.forEach((campaign, campaignIndex) => {
            if (campaign && campaign.adgroupList) {
              this.updatedCampaigns[campaignIndex].adgroupList = campaign.adgroupList.map(adgroup => {
                const bidField = this.getBidFieldName(adgroup.optimizationGoal)
                return {
                  ...adgroup,
                  ...(bidField && { [bidField]: this.roasBid }),
                }
              })
            }
          })
        }

        this.$emit('update-campaigns', this.updatedCampaigns)
        this.hideModal()
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
#bulk-edit-bid-modal {
  .modal-content {
    .modal-body {
      height: 100%;
    }

    .form-control:focus, .input-group:focus-within .form-control {
      border-color: #e0e0e5 !important;
    }

  }

  .bulk-edit-input {
    .vs__selected-options {
      width: 90%;
      .vs__selected {
        width: 90%;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.wrap-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
